import styled from 'styled-components';
import { COLORS } from '../../../../../../../constants/radar';

export const SelectorContainer = styled.div`
  display: flex;
  gap: 4px;
  margin-top: 4px;
  width: 60%;
`;

export const TypeButton = styled.button`
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 2px;
  padding: 4px 8px;
  min-height: 48px;
  border: 1px solid ${props => props.selected ? COLORS.PRIMARY : COLORS.BACKGROUND};
  border-radius: 4px;
  background-color: ${props => props.selected ? `${COLORS.PRIMARY}10` : 'white'};
  cursor: ${props => props.disabled ? 'not-allowed' : 'pointer'};
  transition: all 0.2s ease;
  opacity: ${props => props.disabled ? 0.6 : 1};

  &:hover:not(:disabled) {
    background-color: ${props => props.selected ? `${COLORS.PRIMARY}20` : COLORS.BACKGROUND};
    transform: translateY(-0.5px);
  }

  &:focus {
    outline: none;
    box-shadow: 0 0 0 1px ${COLORS.BACKGROUND};
  }
`;

export const TypeIcon = styled.span`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 64px;
  height: 64px;

  > svg {
    width: 100%;
    height: 100%;
    color: ${props => props.selected ? COLORS.PRIMARY : COLORS.SECONDARY};
  }
`;

export const TypeLabel = styled.span`
  font-weight: ${props => props.selected ? '600' : '400'};
  color: ${COLORS.PRIMARY};
  font-size: 12px;
  line-height: 1;
`;

export const TypeDescription = styled.p`
  margin: 0;
  font-size: 9px;
  color: ${COLORS.SECONDARY};
  text-align: center;
  line-height: 1.1;
`;
